export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.719 3.04a1 1 0 01.653.032l9 3.613a1.001 1.001 0 010 1.856l-3.007 1.206 3.007 1.208a1 1 0 010 1.857l-3.298 1.323 3.298 1.324a1 1 0 010 1.856l-9 3.613a1 1 0 01-.744 0l-9-3.613a1.001 1.001 0 010-1.856l3.297-1.324-3.297-1.323a1.001 1.001 0 010-1.857l3.006-1.208-3.006-1.206a1 1 0 010-1.856l9-3.613.09-.032zm.653 13.384a.998.998 0 01-.744 0l-3.019-1.212-2.925 1.175L12 18.923l6.315-2.536-2.925-1.175-3.018 1.212zm0-4.27a1 1 0 01-.744 0l-3.31-1.329-2.634 1.058L12 14.419l6.315-2.536-2.634-1.058-3.309 1.33zM5.684 7.612L12 10.15l6.315-2.537L12 5.076 5.684 7.612z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};